import { FunctionComponent } from 'react';

import { Props } from './index';
import StyledComponent from './styles';

interface Chip {
    key: string;
    label: string;
    onRemove: () => void;
}

const PublicLayoutJobsActiveFiltersBar: FunctionComponent<Props> = ({
    jobCategories,
    jobAgreements,
    jobModes,
    jobExperiences,
    jobLanguages,
    jobTimes,

    searchParams,
    onChangeSearchParam,
    onClearFilters,
    onClearAll,
}) => {
    const getSlugChips = (key: string, list: { slug: string; name: string }[]): Chip[] => {
        const values: string[] = searchParams[key]?.getValue?.() || [];

        return values
            .map((slug) => {
                const element = list.find((item) => item.slug === slug);
                if (!element) return null;

                return {
                    key: `${key}-${slug}`,
                    label: element.name,
                    onRemove: () => onChangeSearchParam(key, slug),
                };
            })
            .filter(Boolean);
    };

    const getAgreementChips = (): Chip[] => {
        const values: string[] = searchParams.agreement?.getValue?.() || [];

        if (values.length > 0 && jobAgreements.length > 0 && values.length === jobAgreements.length) {
            const allAgreement = jobAgreements.find((agreement) => /umowa-dowolna/.test(agreement.slug));

            return [{
                key: 'agreement-all',
                label: allAgreement?.name || 'Umowa - dowolna',
                onRemove: () => onClearFilters(['agreement']),
            }];
        }

        return getSlugChips('agreement', jobAgreements);
    };

    const getCityChip = (): Chip[] => {
        const city = searchParams.city?.getValue?.();
        if (!city) return [];

        const radius = searchParams.radius?.getValue?.();

        return [{
            key: 'city',
            label: radius ? `${city.name} +${radius} km` : city.name,
            onRemove: () => onClearFilters(radius ? ['city', 'radius'] : ['city']),
        }];
    };

    const getSalaryChip = (): Chip[] => {
        const salary = searchParams.salary?.getValue?.();
        if (!salary) return [];

        return [{
            key: 'salary',
            label: `Zarobki od ${salary} zł`,
            onRemove: () => onClearFilters(['salary']),
        }];
    };

    const getNameChip = (): Chip[] => {
        const phrase = searchParams.name?.getValue?.();
        if (!phrase) return [];

        return [{
            key: 'name',
            label: phrase,
            onRemove: () => onClearFilters(['name']),
        }];
    };

    const getCvFreeChip = (): Chip[] => {
        const cvFree = searchParams.cvFree?.getValue?.();
        if (!cvFree) return [];

        return [{
            key: 'cvFree',
            label: 'Oferty bez CV',
            onRemove: () => onClearFilters(['cvFree']),
        }];
    };

    const chips: Chip[] = [
        ...getNameChip(),
        ...getCityChip(),
        ...getSlugChips('category', jobCategories),
        ...getAgreementChips(),
        ...getSlugChips('mode', jobModes),
        ...getSalaryChip(),
        ...getSlugChips('experience', jobExperiences),
        ...getSlugChips('language', jobLanguages),
        ...getSlugChips('time', jobTimes),
        ...getCvFreeChip(),
    ];

    if (chips.length === 0) return null;

    return (
        <StyledComponent className="public-layout-jobs-active-filters-bar">
            <div className="chips">
                {chips.map((chip) => (
                    <div
                        className="chip"
                        key={chip.key}
                    >
                        <span className="chip-label">
                            {chip.label}
                        </span>
                        <button
                            type="button"
                            className="chip-remove"
                            onClick={chip.onRemove}
                            aria-label={`Usuń filtr: ${chip.label}`}
                        >
                            ×
                        </button>
                    </div>
                ))}
            </div>
            <button
                type="button"
                className="clear-all"
                onClick={onClearAll}
            >
                Wyczyść filtry
            </button>
        </StyledComponent>
    );
};

export default PublicLayoutJobsActiveFiltersBar;
